import { useEffect, useState } from "react";
import { Grid2, TextField, Typography, Box, Button, Card, CardContent, CardActions, Dialog, DialogContent, LinearProgress, Modal } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import axios from "axios";
import ModalComponent from "./ModalComponent";
import SimilarityResultModal from "./SimilarityResultModal";
import AppButton from "./AppButton";
import { db } from "./firebase";
import { doc, setDoc, increment } from "firebase/firestore";

const MainSection=({email, token})=>{

    const [userEmail,setUserEmail]=useState("");
    const [userToken, setUserToken]=useState("");
    const [resultModal, setResultModal]=useState(false);
    const [responseData, setResponseData]=useState({});
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        setUserEmail(email);
        setUserToken(token);
    },[email, token])

    const templates={
        'Accounting':"/Resumes/ATS Bold accounting resume.jpg",
        'Industry Manager':"/Resumes/Industry manager resume.jpg",
        'Hospital Manager':"/Resumes/Modern hospitality resume.jpg",
        'Entry Level Data Analyst':"/Resumes/Entry-level-data-analyst.jpg",
        'Mid Level Data Analyst':"/Resumes/Mid_Level_Data_CV.jpg",
        'SDE I':"/Resumes/SDE_Template.jpg",
        'Senior Data Scientist':"/Resumes/Senior-data-scientist-resume.jpg",
        'Senior Front End Dev':"/Resumes/Senior-front-end-developer.jpg"
    }

    const [open, setOpen] = useState(false);
    const [currentDoc, setCurrentDoc] = useState(null);
    const [jobDescription, setJobDescription] = useState("Paste job description here...");
    const [resumeFile, setResumeFile] = useState(null);
    const [message, setMessage] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const handleSetMessage=(msg)=>{
        setMessage(msg);
        setOpenModal(true);
    }

    const handleCloseModal=()=>{
        setOpenModal(false);
    }

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file && resumeFile!=null) {
            handleSetMessage("please select a file...");
            return;
        }
        const validFormats = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
        if (!validFormats.includes(file.type)) {
            handleSetMessage("Invalid file format. Please upload a PDF or DOCX file.");
            return;
        }
        setResumeFile(file);
    };

    const handleSimilarityCheck = async () => {
        if (!resumeFile) {
            handleSetMessage("Please upload a resume...");
            return;
        }
        if(jobDescription.length<50){
            handleSetMessage("Please enter a proper description with at least 50 characters...");
            return;
        }
        const formData = new FormData();
        formData.append("job_description", jobDescription);
        formData.append("resume", resumeFile);
        formData.append("token",userToken);
        formData.append("email",userEmail);

        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/calculate-similarity`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            await setDoc(doc(db, "users", email), { usageCount: increment(1) }, { merge: true });
            setResponseData(response.data);
            setResultModal(true);
        } catch (error) {
            handleSetMessage("An error occurred while calculating the score. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handlePreview = (doc) => {
        setCurrentDoc(doc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentDoc(null);
    };

    const handleDownload = (fileUrl) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileUrl.split('/').pop().replace('.jpg','.docx');
        link.click();
    };

    return(
        <Box sx={{margin:{sx:'1rem', sm:'3rem', md:'5rem'}, marginBottom:'0.2rem !important'}} >
            {openModal===true?
                <ModalComponent msg={message} handleCloseModal={()=>handleCloseModal()}/>:<></>
            }
            <Modal open={loading} aria-labelledby="loading-modal-title" aria-describedby="loading-modal-description">
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 300, bgcolor: 'background.paper',
                    borderRadius: 2, boxShadow: 24, p: 4, textAlign: 'center',
                }}>
                    <Typography id="loading-modal-title" variant="h6" gutterBottom>
                        Calculating Similarity...
                    </Typography>
                    <LinearProgress />
                </Box>
            </Modal>
            <SimilarityResultModal
                open={resultModal}
                onClose={() => setResultModal(false)}
                data={responseData}
            />
            <Grid2 container spacing={1} sx={{background:'white'}}>
                <Grid2 size={{xs:12, sm:12, md:8}} sx={{padding:'1rem'}}>
                    <Typography sx={{fontSize:'1rem'}}>Job Description</Typography>
                    <TextField multiline label={'Paste job description here...'} onChange={(e)=>setJobDescription(e.target.value)} rows={12} sx={{margin:'1.5rem 0', width:'100%'}}/>
                </Grid2>
                <Grid2 size={{xs:12, sm:12, md:4}} sx={{padding:'1rem'}}>
                    <Typography sx={{fontSize:'1rem'}}>Upload Resume</Typography>
                    <Box sx={{margin:'1.5rem 0', padding:'1rem 0', width:'100%', height:'fit-content', border:'dotted',
                        display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
                        <CloudUploadIcon sx={{fontSize:{xs:'4rem',sm:'6rem'}}}/>
                        <Typography>Upload resume here...</Typography>
                        <TextField
                            type="file"
                            inputProps={{ accept: ".pdf,.docx" }}
                            onChange={handleFileUpload}
                            sx={{ display: "none" }}
                            id="file-input"
                        />
                        <label htmlFor="file-input">
                            <AppButton component="span" sx={{ margin: '1rem' }}>
                                Browse Files
                            </AppButton>
                        </label>
                        {resumeFile && (
                            <Typography sx={{ marginTop: "1rem", fontSize:'0.6rem', color:'green' }}>
                                Selected File: {resumeFile.name}
                            </Typography>
                        )}
                        <Typography variant="body2">Supported formats: PDF, DOCX</Typography>
                    </Box>
                </Grid2>
            </Grid2>
            <Grid2>
                <Grid2 sx={{display:'flex', justifyContent:'center', background:'white'}}>
                    <AppButton sx={{ margin: '1rem' }} onClick={() => handleSimilarityCheck()}>
                        Run ATS Verifier
                    </AppButton>
                </Grid2>
            </Grid2>
            <Grid2 sx={{padding:'2rem 0'}}>
                <Typography sx={{fontSize:(theme)=>theme.typography.h5,
                    fontWeight:(theme)=>theme.typography.fontWeightBold, textAlign:'center'}}>Resume Templates</Typography>
                <Grid2 container spacing={1.5} sx={{padding:'1.5rem 0', display:'flex',
                    flexDirection:{xs:'column', sm:'row', md:'row'}, alignContent:'center'}}>
                    {(Object.entries(templates)).map(([key,value],index)=>(
                        <Grid2 key={index} size={{xs:10, sm:6, md:4}}>
                        <Card sx={{ width:'100%' }}>
                            <Box sx={{ maxHeight: '400px', overflow: 'hidden', padding: '1rem' }}>
                                <img src={value} alt="Resume" width='100%' />
                            </Box>
                            <CardContent>
                                <Typography gutterBottom variant="body1" fontWeight={'600'} component="div">
                                   {key}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <AppButton size="small" onClick={() => handlePreview(value)}>Preview</AppButton>
                                <Button onClick={()=>handleDownload(value)}><DownloadIcon sx={{color:'black'}}/></Button>
                            </CardActions>
                        </Card>

                        <Dialog open={open} onClose={handleClose}
                            aria-labelledby="dialog-title"
                            disableEnforceFocus
                            aria-describedby="dialog-description">
                            <DialogContent sx={{height:"842px", width:"600px", maxWidth:'100%'}}>
                                <img src={currentDoc} alt="Resume" width='100%'/>
                            </DialogContent>
                        </Dialog>
                    </Grid2>
                    ))}
                </Grid2>
            </Grid2>
        </Box>
    )
}
export default MainSection;
